import React, { FC } from 'react';
import { Typography } from '@mui/material';
import {
  IAllContractShifts,
  ICalendarEventType,
  PharmacistLegendVariant,
  WorkshiftStatus,
} from '@pharmaplan/common';
import ServiceCard from '../ServiceCard';
import strings from '../../../localization';
import classes from './styles';
import NoteLabelValue from '../../common/NoteLabelValue';
import TotalContractValue from '../../common/TotalContractValue';

interface ILongTermWorkshiftDetails {
  shifts: Array<IAllContractShifts>;
  contractValue: number;
  allowances?: string;
  proposedAllowances?: string;
  type: ICalendarEventType;
  bookedShiftCount?:number;
}

const LongTermWorkshiftDetails: FC<ILongTermWorkshiftDetails> = ({
  shifts,
  contractValue,
  allowances,
  proposedAllowances,
  bookedShiftCount,
  type,
}) => {
  const filterBy = {
    [PharmacistLegendVariant.booked]: [WorkshiftStatus.Booked],
    [PharmacistLegendVariant.requested]: [WorkshiftStatus.Requested],
    [PharmacistLegendVariant.workshift]: [
      WorkshiftStatus.Posted,
      WorkshiftStatus.Requested,
      WorkshiftStatus.NotAvailable,
      WorkshiftStatus.Booked,
    ],
  };

  const isBooked = type === PharmacistLegendVariant.booked;

  const getCount = () => {
    if (type === PharmacistLegendVariant.booked) {
      return bookedShiftCount ?? 0;
    }
    return shifts?.filter((item) =>
      filterBy[
        (type ?? PharmacistLegendVariant.workshift) as keyof typeof filterBy
      ].includes(item.status ?? WorkshiftStatus.Posted)).length;
  };

  return (
    <>
      {!isBooked && (
      <ServiceCard
        customContainerStyle={classes.applyContainer}
        content={(
          <Typography sx={classes.applyNote}>
            {strings.applyBasedOnAvailabilityNote}
          </Typography>
        )}
      />
      )}

      <TotalContractValue days={getCount()} value={contractValue} />

      {allowances && (
        <ServiceCard
          customContainerStyle={classes.padTop}
          content={
            <NoteLabelValue label={strings.allowances} value={allowances} />
          }
        />
      )}

      {proposedAllowances && (
        <ServiceCard
          customContainerStyle={classes.padTop}
          content={(
            <NoteLabelValue
              label={strings.proposedAllowances}
              value={proposedAllowances}
            />
          )}
        />
      )}
    </>
  );
};
export default LongTermWorkshiftDetails;
